<!--
 * @Description: 各篇内容有效点击排行
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div class="bi-tmpl-detail__right__cmpt__title">
      {{ curItem.title }}
    </div>
    <div>
      <span style="margin-top: 0" class="bi-tmpl-detail__right__cmpt__title">
        请选择表格样式
      </span>
      <span
        v-if="curItem.tips"
        style="margin-top: 0"
        class="bi-tmpl-detail__right__cmpt__tips"
      >
        {{ curItem.tips }}
      </span>
    </div>

    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div v-for="(item, index) in TYPE_MAPPING" :key="index">
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            style="bottom: -90px"
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            <div :style="getStyle(index)">
              <component
                :is="cmpName(item.value)"
                v-bind="{
                  optionData: {
                    topicSum: 10, //多少题
                    isShowUserSum: 1,
                    userSum: 10,
                    tips: [
                      '专区文章',
                      '总执行数（人或者机构）',
                      '本期有效点击量'
                    ],
                    analysisDimen: '主体分析'
                  }
                }"
              />
            </div>
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import PcModuleSurvey from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-survey';

import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
const CHILD_KEY = '21_1_1';
const TYPE_MAPPING = [1, 2, 3, 4, 5, 6].map(i => {
  return {
    value: 'pc-module-survey-' + i,
    index: i
  };
});

const getStyle: any = index => {
  if (index < 4) {
    return {
      transform: 'scale(0.45) translateY(-600px)',
      transformOrigin: 'center center',
      width: '1024px',
      height: '488px',
      position: 'relative'
    };
  } else {
    return {
      width: '400px',
      margin: '-70px 0 0'
    };
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleSurvey.filter(comp => comp.__name === name)[0];
};
</script>
<style scoped lang="scss"></style>
